/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stat_FoulsInputs */

const th_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟาวล์`)
};

const en_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fouls`)
};

const ja_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファウル`)
};

const zh_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`犯规`)
};

const es_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faltas`)
};

const pt_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faltas`)
};

const id_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelanggaran`)
};

const fr_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fautes`)
};

const tl_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foul`)
};

const vi_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi`)
};

const ko_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파울`)
};

const de_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fouls`)
};

const ru_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фолы`)
};

const tr_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faul`)
};

const it_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falli`)
};

const pl_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faule`)
};

const uk_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фоли`)
};

const hi_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाउल`)
};

const ar_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأخطاء`)
};

const ms_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesalahan`)
};

const bn_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফাউল`)
};

const zh_tw2_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`犯規`)
};

const zh_hk2_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`犯規`)
};

const ur_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فاؤل`)
};

const fa_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطا`)
};

const sw_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makosa`)
};

const nl_stat_fouls = /** @type {(inputs: Stat_FoulsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fouten`)
};

/**
* | output |
* | --- |
* | "Fouls" |
*
* @param {Stat_FoulsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const stat_fouls = /** @type {((inputs?: Stat_FoulsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stat_FoulsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_stat_fouls(inputs)
	if (locale === "ja") return ja_stat_fouls(inputs)
	if (locale === "zh") return zh_stat_fouls(inputs)
	if (locale === "es") return es_stat_fouls(inputs)
	if (locale === "pt") return pt_stat_fouls(inputs)
	if (locale === "id") return id_stat_fouls(inputs)
	if (locale === "fr") return fr_stat_fouls(inputs)
	if (locale === "tl") return tl_stat_fouls(inputs)
	if (locale === "vi") return vi_stat_fouls(inputs)
	if (locale === "ko") return ko_stat_fouls(inputs)
	if (locale === "de") return de_stat_fouls(inputs)
	if (locale === "ru") return ru_stat_fouls(inputs)
	if (locale === "tr") return tr_stat_fouls(inputs)
	if (locale === "it") return it_stat_fouls(inputs)
	if (locale === "pl") return pl_stat_fouls(inputs)
	if (locale === "uk") return uk_stat_fouls(inputs)
	if (locale === "hi") return hi_stat_fouls(inputs)
	if (locale === "ar") return ar_stat_fouls(inputs)
	if (locale === "ms") return ms_stat_fouls(inputs)
	if (locale === "bn") return bn_stat_fouls(inputs)
	if (locale === "zh-TW") return zh_tw2_stat_fouls(inputs)
	if (locale === "zh-HK") return zh_hk2_stat_fouls(inputs)
	if (locale === "ur") return ur_stat_fouls(inputs)
	if (locale === "fa") return fa_stat_fouls(inputs)
	if (locale === "sw") return sw_stat_fouls(inputs)
	if (locale === "nl") return nl_stat_fouls(inputs)
	return en_stat_fouls(inputs)
});